import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ModuleContainer from '../components/ModuleContainer';
import HomecardGrid from '../components/HomecardGrid';
import CollapsibleText from '../components/CollapsibleText';
import CallToAction from '../components/CallToAction';

import { SeoCitiesConsumer } from '../context/SeoCitiesContext';

import './Homecards.scss';

const SPANISH_REGION = [
  'barcelona',
  'bilbao',
  'granada',
  'madrid',
  'seville',
  'valencia',
  'cordoba'
];
const TEXT_CLASS_NAME = 'homecard-text';
const LAST_CLASS_NAME = 'homecard-text--last';

const getTextClassName = currentCity =>
  SPANISH_REGION.includes(currentCity)
    ? `${TEXT_CLASS_NAME} ${LAST_CLASS_NAME}`
    : TEXT_CLASS_NAME;

const Homecards = ({ title, text, homecards, seeMoreLink, highlighted }) => (
  <ModuleContainer highlighted={highlighted}>
    <h2 className="homecards-title">{title}</h2>
    <SeoCitiesConsumer>
      {({ currentCity }) => (
        <CollapsibleText
          className={getTextClassName(currentCity)}
          text={text}
        />
      )}
    </SeoCitiesConsumer>
    <HomecardGrid homecards={homecards} />
    <div className="homecards-show-more">
      <CallToAction link={seeMoreLink}>
        {trans('landingpage.label.show_me_more')}
      </CallToAction>
    </div>
  </ModuleContainer>
);

Homecards.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  homecards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  seeMoreLink: PropTypes.string.isRequired,
  highlighted: PropTypes.bool
};

Homecards.defaultProps = {
  highlighted: false
};

export default Homecards;
